import { lazy } from 'react'

const ValueCompendiumViewAsync = lazy(() => {
    return import(/* webpackChunkName: "ValueCompendium" */ './ValueCompendium')
})

export default ValueCompendiumViewAsync
